import { useCallback, useEffect, useState } from 'react';
import { useRestaurantContext } from '../contexts/RestaurantContext';

const useRestaurantData = <T>(fetchData: () => Promise<T>) => {
  const { currentRestaurant } = useRestaurantContext();
  const restaurantID = currentRestaurant?.restaurantID;
  const [requested, setRequested] = useState(false);
  const [data, setData] = useState<T | null>(null);
  const [loadedRestaurantID, setLoadedRestaurantID] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!requested || restaurantID == null || restaurantID === loadedRestaurantID) return undefined;

    let canceled = false;
    setIsLoading(true);
    setHasError(false);

    fetchData()
      .then((result) => {
        if (canceled) return;
        setData(result);
        setLoadedRestaurantID(restaurantID);
        setIsLoading(false);
      })
      .catch((error) => {
        if (canceled) return;
        if (error?.response?.status !== 401) {
          setHasError(true);
        }
        setIsLoading(false);
      });

    return () => {
      canceled = true;
    };
  }, [requested, restaurantID, loadedRestaurantID, fetchData]);

  const load = useCallback(() => setRequested(true), []);

  return { data, setData, isLoading, hasError, load };
};

export default useRestaurantData;
